import * as React from 'react';
import { buildClassString } from '../StringUtils';
import './style/index.scss';
const maxSearchLength = 50;
class SearchInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, { value: '' });
        this.focus = this.focus.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onClearSearch = this._onClearSearch.bind(this);
        this._onMouseDown = this._onMouseDown.bind(this);
        this._onKeyDown = this._onKeyDown.bind(this);
    }
    clear() {
        this._updateValue('');
    }
    setValue(txt) {
        this._updateValue(txt);
    }
    focus() {
        if (this._inputRef) {
            this._inputRef.focus();
        }
    }
    render() {
        const { inputRef, inputRole, onBlur, onClick, onFocus, placeholderText } = this.props;
        const { value } = this.state;
        const clearButtonClass = buildClassString({
            'search-input__clear-btn': true,
            'hidden': !value
        });
        return (React.createElement("div", { className: "pxl-form-control search-input", onClick: this.focus, onMouseDown: this._onMouseDown },
            React.createElement("i", { className: "icon-search", "aria-hidden": "true" }),
            React.createElement("input", { autoComplete: "off", className: "search-input__input", placeholder: placeholderText, ref: ref => {
                    this._inputRef = ref;
                    if (inputRef) {
                        inputRef(ref);
                    }
                }, role: inputRole, type: "text", onBlur: onBlur, onClick: onClick, onChange: this._onChange, onFocus: onFocus, onKeyDown: this._onKeyDown, maxLength: maxSearchLength, value: value }),
            React.createElement("button", { className: clearButtonClass, onClick: this._onClearSearch },
                React.createElement("i", { className: "search-input__clear-icon icon-cancel" }))));
    }
    _onClearSearch(e) {
        this._updateValue('');
    }
    _onChange(e) {
        const searchString = e && e.target ? e.target.value.substr(0, maxSearchLength) : '';
        this._updateValue(searchString);
    }
    _onMouseDown(e) {
        if (e.target !== this._inputRef) {
            e.preventDefault();
        }
    }
    _onKeyDown(e) {
        const { clearOnEscape, onKeyDown } = this.props;
        if (onKeyDown) {
            onKeyDown(e);
        }
        if (!e.isDefaultPrevented() && e.key === 'Escape' && clearOnEscape) {
            this.clear();
            if (this._inputRef) {
                this._inputRef.blur();
            }
        }
    }
    _updateValue(newValue) {
        const { onChange } = this.props;
        const { value } = this.state;
        if (newValue === value) {
            return;
        }
        this.setState({ value: newValue });
        if (onChange) {
            onChange(newValue);
        }
    }
}
SearchInput.defaultProps = {
    clearOnEscape: true
};
export { SearchInput };
export default SearchInput;
